import { Provider } from '@angular/core';
import {
  CreateVesselActivityRecordUseCase,
  DeleteVesselActivityRecordUseCase,
  GetVesselActivityPhaseFormUseCase,
  GetVesselActivityRecordAuditLogsUseCase,
  ListVesselActivityPhasesUseCase,
  ListVesselActivityRecordsUseCase,
  UpdateVesselActivityRecordUseCase,
} from '@app/application/use-cases/vessel-activity-phase';
import { VesselActivityPhaseRepository } from '@app/domain/repositories/vessel-activity-phase.repository';
import { VesselActivityPhaseRepositoryImpl } from '../repositories/vessel-activity-phase.repository.impl';

export const VESSEL_ACTIVITY_PHASE_PROVIDERS: Provider[] = [
  {
    provide: VesselActivityPhaseRepository,
    useClass: VesselActivityPhaseRepositoryImpl,
  },
  {
    provide: ListVesselActivityPhasesUseCase,
    useFactory: (repo: VesselActivityPhaseRepository) =>
      new ListVesselActivityPhasesUseCase(repo),
    deps: [VesselActivityPhaseRepository],
  },
  {
    provide: ListVesselActivityRecordsUseCase,
    useFactory: (repo: VesselActivityPhaseRepository) =>
      new ListVesselActivityRecordsUseCase(repo),
    deps: [VesselActivityPhaseRepository],
  },
  {
    provide: GetVesselActivityPhaseFormUseCase,
    useFactory: (repo: VesselActivityPhaseRepository) =>
      new GetVesselActivityPhaseFormUseCase(repo),
    deps: [VesselActivityPhaseRepository],
  },
  {
    provide: CreateVesselActivityRecordUseCase,
    useFactory: (repo: VesselActivityPhaseRepository) =>
      new CreateVesselActivityRecordUseCase(repo),
    deps: [VesselActivityPhaseRepository],
  },
  {
    provide: UpdateVesselActivityRecordUseCase,
    useFactory: (repo: VesselActivityPhaseRepository) =>
      new UpdateVesselActivityRecordUseCase(repo),
    deps: [VesselActivityPhaseRepository],
  },
  {
    provide: DeleteVesselActivityRecordUseCase,
    useFactory: (repo: VesselActivityPhaseRepository) =>
      new DeleteVesselActivityRecordUseCase(repo),
    deps: [VesselActivityPhaseRepository],
  },
  {
    provide: GetVesselActivityRecordAuditLogsUseCase,
    useFactory: (repo: VesselActivityPhaseRepository) =>
      new GetVesselActivityRecordAuditLogsUseCase(repo),
    deps: [VesselActivityPhaseRepository],
  },
];
